
import processDateAvailableMixin from '~/mixin/process-date-available-mixin';

export default {
  name: "cal-cart-countdown-timer",
  props: ['isTriggerCartCountDown'],
  mixins:[processDateAvailableMixin],
  data() {
    return {
      cutoffs: null,
      countdown: null,
      countdownInterval: null,
      displayTimer: false,
      cartItems: [],
      cartItem: {},
      deliveryDate: '',
      deliveryTown: {},
      intervalId:null,
      recipientCity:'',
    };
  },
  async created() {
    await this.triggerCartTimeCounter();
  },
  watch: {
    isTriggerCartCountDown() {
      this.triggerCartTimeCounter();
    }
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.triggerCartTimeCounter();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    async triggerCartTimeCounter() {
      let status={}
      let deliveryDate=[];

      if(this.$route.path.includes('cart')){
        this.cartItems = sessionStorage.cartItems ? JSON.parse(sessionStorage.cartItems) : null;
        let deliveryInfoOfOrders=this.getDeliveryInfoOfOrdersFromCart(this.cartItems);
        const closestDeliveryDate= this.getClosestDeliveryDateInfo(deliveryInfoOfOrders);
        deliveryDate=closestDeliveryDate.deliveryDate;
        this.deliveryTown=closestDeliveryDate.deliveryTown;
        this.recipientCity=closestDeliveryDate.recipientCity;
      }else{
        deliveryDate=sessionStorage.deliveryDate?[sessionStorage.deliveryDate]:[];
        this.deliveryTown=sessionStorage.deliveryTown?JSON.parse(sessionStorage.deliveryTown):'';
      }
      if(deliveryDate.length<1 || !this.deliveryTown){
        this.handleError();
        return '';
      }
      await this.getCutoffs();

      status = this.checkCutoffStatus(this.cutoffs,deliveryDate);
      if(status[0].status.daysRemaining >= 2 ){
           this.timerDisplayOff();
           return ''
        }
      if(status[0].status==='Cutoff has already passed'){
         let date=  this.$dayjs(deliveryDate[0]).format("ddd, MMMM Do");
         this.countdown=`Oops - we missed the deadline for ${date}. Please choose another date for delivery!`
      }else{
         let daysRemaining =status[0].status.daysRemaining;
         daysRemaining= daysRemaining>1?`${daysRemaining} days `:`${daysRemaining>0?daysRemaining+ ' day ':''} `;

         let hoursRemaining =status[0].status.hoursRemaining;
         hoursRemaining= hoursRemaining>1?`${hoursRemaining} hours `:`${hoursRemaining>0?hoursRemaining+' hour ':''} `;

         let minutesRemaining =status[0].status.minutesRemaining;
         minutesRemaining= minutesRemaining>1?`${minutesRemaining} minutes `:`${minutesRemaining>0?minutesRemaining+' minute':''} `;


        if(status[0].status.daysRemaining>=1){
          minutesRemaining='';
        }

         let time = daysRemaining + (daysRemaining.trim() !== ""? 'and ': '') +' '+ hoursRemaining + (hoursRemaining.trim() !== ""? 'and ': '') +' '+ minutesRemaining ;
         let date =this.$dayjs(deliveryDate[0]).format("dddd, MMMM Do");
         let city =this.recipientCity
         this.countdown = this.$t("countdown_timer_msg", { time, date, city })
         this.displayTimer=true;
      }
    },
    async getCutoffs() {
      try {
        const city = this.deliveryTown.regionTag;
        this.cutoffs = await this.$axios.$get(
          `v3/region/cutoff/${city}`,
          {
            headers: {
              "callia-lang": this.$i18n.locale,
            },
          }
        );
      } catch (error) {
        console.error(error);
        this.handleError();
      }
    },
    timerDisplayOff() {
      this.displayTimer = false;
      clearInterval(this.countdownInterval);
    },
    handleError() {
      this.displayTimer = false;
      clearInterval(this.countdownInterval);
      return;
    },
    getDeliveryInfoOfOrdersFromCart(cartItem){
      let deliveryInfo =[]
      Object.keys(this.cartItems).forEach(key=>{
        let item = cartItem[key];
        deliveryInfo.push({deliveryDate:item.deliveryWindow.deliveryDate, deliveryTown:item.deliveryTown, recipientCity:item.recipient.city})
      })
      return deliveryInfo;
    },
    getClosestDeliveryDateInfo(deliveryInfoOfOrders) {
      const closestDeliveryDateInfo = {deliveryDate:[],deliveryTown:{}, recipientCity:''}
      const today = this.$dayjs();

      const closestDateInfo = deliveryInfoOfOrders.reduce((closest, current) => {
      const currentDiff = Math.abs(this.$dayjs(current.deliveryDate).diff(today, 'day'));
      const closestDiff = Math.abs(this.$dayjs(closest.deliveryDate).diff(today, 'day'));
      return currentDiff < closestDiff ? current : closest;
    });
    closestDeliveryDateInfo.deliveryDate.push(closestDateInfo.deliveryDate);
    closestDeliveryDateInfo.deliveryTown=closestDateInfo.deliveryTown;
    closestDeliveryDateInfo.recipientCity=closestDateInfo.recipientCity;
    return closestDeliveryDateInfo;
    }
  }
}
